import type { CobaltSyncConfig, CobaltSyncRun } from './types'

const TERMINAL_SYNC_STATUSES = new Set(['succeeded', 'failed', 'cancelled'])

export function cobaltLastSyncAt(
  run: CobaltSyncRun | null | undefined
): Date | null {
  if (!run || !TERMINAL_SYNC_STATUSES.has(run.status)) return null

  const date = new Date(run.completed_at ?? run.updated_at)
  return Number.isNaN(date.getTime()) ? null : date
}

export function nextCobaltSyncAt(
  config: CobaltSyncConfig | null | undefined
): Date | null {
  return config?.next_run_at ? new Date(config.next_run_at) : null
}

export function formatCobaltSyncTime(date: Date, timezone?: string): string {
  try {
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      timeZone: timezone,
      timeZoneName: 'short',
    }).format(date)
  } catch {
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    }).format(date)
  }
}
